import { useState } from "react";
import MainLayout from "../components/layouts/MainLayout";
import { getCookiePreferences } from "../helpers/cookies";
import localized from "../locale/locales";
import { useRouter } from "next/router";
import Typo from "../components/Typo";
import ConceptCarousel from "../components/ConceptCarousel";
import SectionConceptHeader from "../components/sections/SectionConceptHeader";
import SectionConceptIntro from "../components/sections/SectionConceptIntro";
import SectionFeatures from "../components/sections/SectionFeatures";
import SectionPersonBlock from "../components/sections/SectionPersonBlock";
import Video from "../components/Video";
import Lightbox from "../components/Lightbox";
import ScheduleTrial from "../components/ScheduleTrial";

// Features icons
import iconAI from "../public/img/icons/ai.png";
import iconStar from "../public/img/icons/star.png";
import iconPerson from "../public/img/icons/person.png";
import iconModes from "../public/img/icons/modes.png";
import iconTick from "../public/img/icons/tick.png";
import iconEffectivity from "../public/img/icons/effectivity.png";
import Container from "../components/Container";
import Gallery from "../components/Gallery";
import { getInitialTrialSlots } from "../helpers/api/trial-slots";

// Gallery images
import imageGallery01 from "../public/img/gallery/biostrength/1.jpg";
import imageGallery02 from "../public/img/gallery/biostrength/2.jpg";
import imageGallery03 from "../public/img/gallery/biostrength/3.jpg";
import imageGallery04 from "../public/img/gallery/biostrength/4.jpg";

const icons = [
  iconAI,
  iconStar,
  iconPerson,
  iconModes,
  iconTick,
  iconEffectivity,
];

export default function Biostrength({
  trialSlotsResponse,
  hasCookiePreferences,
  cookiePreferences,
}) {
  const { locale } = useRouter();
  const { bioCircuit: lang } = localized[locale];

  const [hiddenNav, setHiddenNav] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const handlePlayVideo = () => {
    setActiveVideo("/videos/bio_circuit_web.mp4");
    setShowPopup(true);
    setHiddenNav(true);
  };

  return (
    <MainLayout
      hasCookiePreferences={hasCookiePreferences}
      cookiePreferences={cookiePreferences}
      hiddenNav={hiddenNav}
      footerTheme="dark"
      image={`https://nextmove.cz/img/og/${locale}_og-image_biostrength.png`}
      title={lang.og.title}
      description={lang.og.description}
    >
      <Lightbox
        active={showPopup}
        onClose={() => {
          setShowPopup(false);
          setActiveVideo(null);
          setHiddenNav(false);
        }}
      >
        <Video url={activeVideo} active={showPopup} />
      </Lightbox>

      <SectionConceptHeader
        mobileVideo="/videos/hero/biostrength_mobile.mp4"
        tabletVideo="/videos/hero/biostrength_tablet.mp4"
        desktopVideo="/videos/hero/biostrength_desktop.mp4"
        align="bottom"
        title={lang.header.title}
        body={lang.header.body}
        className="max-w-[430px] pb-20"
      />

      <SectionConceptIntro title={lang.intro.title} body={lang.intro.body} />

      <div
        style={{
          background:
            "linear-gradient(to bottom,rgba(255,255,255,1) 0%,rgba(255,255,255,1) 50%,rgba(0,0,0,1) 50%,rgba(0,0,0,1) 100%)",
        }}
      >
        <Container fullMobile={true}>
          <Gallery
            images={[
              imageGallery01,
              imageGallery02,
              imageGallery03,
              imageGallery04,
            ]}
          />
        </Container>
      </div>

      <SectionFeatures
        items={lang.features}
        icons={icons}
        className="pt-24 md:pb-24"
      />

      <div className="pt-16 md:pt-0">
        <SectionPersonBlock
          video={"/videos/veru_d.mp4"}
          name={lang.trainerBlock.trainer.name}
          description={lang.trainerBlock.trainer.description}
          title={lang.trainerBlock.title}
          body={lang.trainerBlock.body}
        />
      </div>

      {/*<CtaBanner title={lang.banner.title}*/}
      {/*           body={lang.banner.body}*/}
      {/*           cta={{*/}
      {/*               href: '/#free-trial',*/}
      {/*               label: lang.banner.cta*/}
      {/*           }}*/}
      {/*           background={bannerImage}*/}
      {/*/>*/}

      <section className="bg-black text-white">
        <ConceptCarousel items={lang.carousel.items}>
          <Typo>
            <span dangerouslySetInnerHTML={{ __html: lang.carousel.title }} />
          </Typo>
        </ConceptCarousel>
      </section>

      <ScheduleTrial
        initialSlots={trialSlotsResponse}
        setHiddenNav={setHiddenNav}
        className="py-24"
      />
    </MainLayout>
  );
}

export async function getServerSideProps({ req, res }) {
  const cookiePreferences = getCookiePreferences(req);
  const trialSlots = await getInitialTrialSlots();

  return {
    props: {
      trialSlotsResponse: trialSlots,
      ...cookiePreferences,
    },
  };
}
